import { defineField, defineType } from 'sanity'
import { richTextSimple } from '../../data/richText'

export default defineType({
  name: 'transparentBoxes',
  title: 'Transparent boxes',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Background image',
      name: 'backgroundImage',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Items',
      name: 'items',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'transparentBoxItem',
          fields: [
            defineField({
              title: 'Title',
              name: 'title',
              type: 'string',
            }),
            defineField({
              title: 'Content',
              name: 'content',
              type: 'array',
              of: richTextSimple,
            }),
          ],
          preview: {
            select: {
              title: 'title',
              media: 'images.0',
            },
            prepare({ title, media }) {
              return {
                title,
                subtitle: 'Transparent Box Item',
                media,
              }
            },
          },
        },
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'Transparent boxes',
      }
    },
  },
})